import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import largeurgent from "../../practices_images/large-urgent.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const LargeUrgent = () => {
  return (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
    <div className="cap-container">
    <h1>Large Urgent Care Centers – Coming Soon</h1>

    <div className="cap-section">
        {/* Text Content */}
        <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Preparing to support care at scale</h3>
            <p>
              As demand for urgent care continues to grow, large urgent care organizations are emerging to serve higher patient volumes across multiple locations. These environments require disciplined operations, scalable systems, and clear financial oversight to maintain performance and consistency.
            </p>
            <p>
              Large urgent care centers operate with many of the same pressures as hospitals, while maintaining the speed and accessibility that define urgent care delivery.
            </p>

            <h3>The Operating Environment</h3>
            <p>
              Large urgent care organizations manage complex, multi location operations where patient flow, documentation, billing, and technology must remain aligned across sites. Small inefficiencies can quickly scale into material operational and financial risk.
            </p>
            <p>
              Leadership teams must balance rapid growth with standardization, compliance, and visibility across the organization.
            </p>

            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Direction">
              <p>
                We are expanding our capabilities to support large urgent care organizations with the operational clarity and financial discipline required at scale.
              </p>
              <p>
                Our planned focus includes strengthening revenue cycle processes, supporting documentation and billing consistency across locations, improving financial and operational visibility, and reinforcing technology and security practices that support multi site environments.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Building the Foundation">
              <p>
                Our approach to large urgent care organizations is deliberate and structured.
              </p>
              <p>
                We are developing the systems, expertise, and delivery model needed to support large, complex urgent care operations responsibly. These capabilities are currently in development and will be introduced once they are fully established.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Looking Ahead">
              <p>
                Large urgent care organizations will continue to play an increasingly important role in access to care.
              </p>
              <p>
                We are preparing to support this next phase with care, discipline, and purpose.
              </p>
              <p>
                More information on our large urgent care services will be available soon.
              </p>
            </CollapsibleSection>
        </div>

        {/* Image Section */}
        <div className="image-container">
        {<img src={largeurgent} alt="Large Urgent Cares - Coming Soon" />}
        </div>
    </div>
    </div>

  </motion.div>
  );
};

export default LargeUrgent;
